import React from "react";
import {
  FaAward,
  FaTools,
  FaWrench,
  FaCubes,
  FaStamp,
  FaLock,
  FaClipboardCheck,
  FaBoxes
} from "react-icons/fa";

const whyChooseItems = [
  { icon: <FaAward />, title: "ISI Certified Material", desc: "Best quality, ISI certified material by TATA, Jindal, Posco and Other." },
  { icon: <FaTools />, title: "Perfect Press Brake Bending", desc: "Every part perfect bending by press brake machine." },
  { icon: <FaWrench />, title: "High Quality MIG Welding", desc: "High quality MIG welding, perfect grinding and finishing." },
  { icon: <FaCubes />, title: "Quality Hardware & Fittings", desc: "Quality Hardware & best accessories use and perfect fitting of every part." },
  { icon: <FaStamp />, title: "Hard Emboss", desc: "Hard emboss texture for authentic quality and premium finish." },
  { icon: <FaLock />, title: "Heavy Inside Bolt Fitting", desc: "Heavy fitting by inside bolt for strong & durable construction." },
  { icon: <FaClipboardCheck />, title: "Quality Check", desc: "Quality check of every product before heavy box packing." },
  { icon: <FaBoxes />, title: "Proper Packaging", desc: "Proper & safe heavy box packing for damage-free delivery." }
];

export default function WhyChooseUs() {
  return (
    <section className="section-padding light-section">
      <div className="container text-center position-relative z-1">
        <span className="section-pill mb-3">Why Choose Shree Kamdhenu</span>
        <h2 className="section-heading text-dark mb-2 fs-3 fs-md-2">
          Why Choose <span className="text-primary fst-italic">Shree Kamdhenu?</span>
        </h2>
        <p className="text-primary fw-bold mb-4 mb-md-5 fs-6 text-uppercase" style={{ letterSpacing: "2px" }}>
          Quality &bull; Precision &bull; Strength &bull; Reliability
        </p>

        <div className="row g-3 g-md-4">
          {whyChooseItems.map((feature, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-lg-3">
              <div className="feature-card white-card h-100 p-3 p-md-4 rounded-4 transition-all hover-lift text-center">
                <div className="feature-icon mb-2 mb-md-3 fs-2 fs-md-1 text-primary">{feature.icon}</div>
                <h5 className="font-serif fw-bold text-dark mb-2" style={{ fontSize: "1.05rem" }}>
                  {feature.title}
                </h5>
                <p className="text-muted-dark small mt-1 mb-0" style={{ lineHeight: "1.6" }}>
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
